import React, { useMemo } from 'react';
import { mdiCheck } from '@mdi/js';
import { IconSize } from '../../../..';
import { formatBytes } from '../../../../utils/bytes';
import { InstalledContainer, CheckmarkIcon, ProgressContainer, DownloadContainer, ProgressTextContainer, StyledProgressBar, ImportContainer } from './lab.styles';
export const InstallProgress = ({ importProgress, downloadProgress, isLabReady, totalSize }) => {
    const totalSizeFormatted = useMemo(() => formatBytes(totalSize, 2), [totalSize]);
    const importPercentage = useMemo(() => importProgress / Math.pow(10, 2), [importProgress]);
    const downloadPercentage = useMemo(() => downloadProgress / Math.pow(10, 2), [downloadProgress]);
    const downloadedFormatted = useMemo(() => formatBytes(totalSize * downloadPercentage, 2), [
        downloadPercentage,
        totalSize
    ]);
    const importFormatted = useMemo(() => formatBytes(totalSize * importPercentage, 2), [importPercentage, totalSize]);
    if (isLabReady)
        return (React.createElement(InstalledContainer, null,
            React.createElement(CheckmarkIcon, { path: mdiCheck, size: IconSize.Medium }),
            " Installed"));
    return (React.createElement(ProgressContainer, null,
        React.createElement(DownloadContainer, null,
            React.createElement(ProgressTextContainer, null,
                downloadProgress === 100 ? (React.createElement(React.Fragment, null,
                    React.createElement(CheckmarkIcon, { path: mdiCheck, size: IconSize.Small }),
                    " ",
                    'Downloaded ')) : ('Downloading... '),
                `${downloadedFormatted} of ${totalSizeFormatted}`),
            React.createElement(StyledProgressBar, { color: 'primary', variant: 'determinate', value: downloadProgress })),
        React.createElement(ImportContainer, null,
            React.createElement(ProgressTextContainer, null,
                importProgress === 100 ? (React.createElement(React.Fragment, null,
                    React.createElement(CheckmarkIcon, { path: mdiCheck, size: IconSize.Small }),
                    " ",
                    'Imported ')) : ('Importing... '),
                `${importFormatted} of ${totalSizeFormatted}`),
            React.createElement(StyledProgressBar, { color: 'primary', variant: 'determinate', value: importProgress }))));
};
//# sourceMappingURL=InstallProgress.js.map